import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { mediaQueries } from '../../../style/global-style';

interface ILabelIconProps {
    horizontal: boolean;
    iconColor: string;
    fontColor: string;
    iconType: string;
}

export const StyledContainer = styled.div<ILabelIconProps>`
    display: flex;
    align-items: center;
    flex-direction: ${(props) => (props.horizontal ? 'column' : 'row')};

    ${(props) =>
        props.horizontal &&
        css`
            @media ${mediaQueries.tabletAndUp} {
                max-width: 100px;
                margin-right: 20px;
            }

            @media ${mediaQueries.smallDesktopAndUp} {
                margin-right: 50px;
            }
        `}
`;

export const StyledIconContainer = styled.div<ILabelIconProps>`
    & > svg {
        fill: ${(props) => props.iconColor};
        height: ${(props) => (props.horizontal ? '30px' : '27px')};
        width: ${(props) => (props.horizontal ? '30px' : '27px')};

        ${(props) =>
            props.horizontal &&
            css`
                @media ${mediaQueries.tablet} {
                    height: 30px;
                    width: 30px;
                }

                @media ${mediaQueries.smallDesktopAndUp} {
                    height: 35px;
                    width: 35px;
                }
            `}
    }
`;

export const StyledAmount = styled.span<ILabelIconProps>`
    font-size: ${(props) => props.theme.fontSize.copyTextL};
    color: ${(props) => props.fontColor};
    font-weight: 600;
    padding: 0 3px 0 5px;

    ${(props) =>
        props.horizontal &&
        css`
            font-size: ${props.theme.fontSize.headlineXS};

            @media ${mediaQueries.smallDesktopAndUp} {
                font-size: ${props.theme.fontSize.headlineS};
            }
        `}
    ${(props) =>
        props.iconType === 'buildYear' &&
        !props.horizontal &&
        css`
            order: 2;
        `}
`;
export const StyledLabel = styled.span<ILabelIconProps>`
    font-size: ${(props) => props.theme.fontSize.copyTextL};
    color: ${(props) => props.fontColor};
    font-weight: ${(props) => (props.horizontal ? '400' : '600')};
    white-space: nowrap;
    text-align: center;
    text-transform: capitalize;
    ${(props) =>
        props.iconType === 'buildYear' &&
        !props.horizontal &&
        css`
            padding-left: 5px;
        `}
`;
